export const ORG = {
  name: "A.S.I. Sicilia ETS",
  tagline: "Affrontiamo la Sordità Insieme",
};

export const NAV_LINKS = [
  { id: "cosa-facciamo", label: "Cosa Facciamo" },
  { id: "aiuto", label: "Chiedi Aiuto" },
  { id: "chi-siamo", label: "Chi Siamo" },
  { id: "blog", label: "Blog" },
  { id: "sostienici", label: "Sostienici" },
  { id: "contatti", label: "Contatti" },
];

// Dati onesti e verificabili (no numeri inventati)
export const FACTS = [
  { value: "100%", label: "Volontariato e no-profit" },
  { value: "ETS", label: "Ente del Terzo Settore" },
  { value: "Messina", label: "c/o A.O.U. \u201cG. Martino\u201d" },
  { value: "€10", label: "Quota associativa annua" },
];

// Servizi riscritti come BENEFICI, in tono umano
export const WHAT_WE_DO_INTRO = {
  title: "Nati dall'esperienza di chi vive l'impianto cocleare",
  text: "Il nostro impegno nasce da chi convive ogni giorno con un impianto cocleare e da chi accompagna un familiare in questo percorso. Lavoriamo per rendere più semplice, informato e inclusivo il cammino di chi ha scelto o sta valutando questa tecnologia.",
};

export const BENEFITS = [
  {
    icon: "HeartHandshake",
    title: "Supporto personalizzato",
    text: "Ascolto e orientamento per chi valuta l'impianto, chi lo ha appena ricevuto e chi lo usa da anni. Spieghiamo le tappe del percorso (valutazione, intervento, attivazione, riabilitazione) e ti mettiamo in contatto con chi l'ha già vissuto.",
    img: "/assets/supporto.jpg",
  },
  {
    icon: "Users",
    title: "Condivisione di esperienze",
    text: "Incontri, gruppi di confronto e momenti di socialità tra portatori di impianto, familiari e candidati. Il racconto diretto è il modo più efficace per affrontare dubbi, paure e nuove possibilità.",
    img: "/assets/chi-siamo.jpg",
  },
  {
    icon: "BookOpen",
    title: "Informazione chiara e aggiornata",
    text: "Notizie utili su tecnologia, accessibilità, diritti e servizi, con la collaborazione di audiologi, chirurghi, logopedisti e tecnici per contenuti affidabili e comprensibili a tutti.",
    img: "/assets/audioprotesista.jpg",
  },
  {
    icon: "Megaphone",
    title: "Sensibilizzazione e advocacy",
    text: "Facciamo conoscere a istituzioni, strutture sanitarie e società civile le esigenze di chi porta un impianto cocleare, promuovendo interventi concreti su assistenza, procedure e continuità del supporto (ricambi, mappaggi, accessibilità).",
    img: "/assets/non-sento.jpg",
  },
  {
    icon: "Accessibility",
    title: "Qualità della vita e inclusione",
    text: "Sosteniamo iniziative che rendono accessibili cultura, scuola, lavoro e vita quotidiana, e collaboriamo a progetti per teatro, cinema, eventi e spazi pubblici, per una piena partecipazione sociale.",
    img: "/assets/paziente.jpg",
  },
  {
    icon: "HandHeart",
    title: "Rete e solidarietà",
    text: "Costruiamo ponti tra le persone: chi ha già percorso la strada accompagna chi sta iniziando. Crediamo nel valore dell'aiuto reciproco e della comunità.",
    img: "/assets/mani.jpg",
  },
];

export const HELP_STEPS = [
  { n: "01", title: "Contattaci", text: "Scrivici dal modulo o chiamaci. Bastano poche informazioni per iniziare." },
  { n: "02", title: "Ti ascoltiamo", text: "Comprendiamo la tua situazione e le tue esigenze, senza fretta e senza giudizio." },
  { n: "03", title: "Ti affianchiamo", text: "Ti accompagniamo passo dopo passo verso la soluzione più adatta a te e alla tua famiglia." },
];

// ATTENZIONE: testimonianze di ESEMPIO da sostituire con storie reali
export const TESTIMONIALS = [
  {
    quote: "Grazie ad A.S.I. Sicilia abbiamo capito come muoverci per l'impianto cocleare di nostro figlio. Non eravamo più soli.",
    author: "Una famiglia di Messina",
  },
  {
    quote: "Mi hanno aiutato con la manutenzione della protesi e con le pratiche. Persone competenti e davvero disponibili.",
    author: "Un socio dell'associazione",
  },
  {
    quote: "Finalmente qualcuno che ascolta e accompagna, con umanità. Consiglio a tutti di rivolgersi a loro.",
    author: "Genitore di una bambina ipoacusica",
  },
];

export const TEAM = [
  { name: "Casano Luigi", role: "Presidente" },
  { name: "Russo Prospera Patrizia Anna", role: "Vicepresidente" },
  { name: "Dezio Rosario", role: "Consigliere" },
  { name: "Bari Rosa", role: "Consigliere" },
  { name: "Vaccarino Franca Maria Tindara", role: "Consigliere" },
  { name: "Lo Duca Virna", role: "Consigliere" },
];

export const BLOG_LIST = [
  {
    slug: "impianto-cocleare-come-funziona",
    title: "Impianto cocleare: come funziona e a chi è indicato",
    excerpt: "Cos'è l'impianto cocleare, in cosa si differenzia dalle protesi acustiche e quando rappresenta la scelta giusta.",
    img: "/assets/impianto.jpg",
    date: "2026",
    tag: "Impianto Cocleare",
  },
  {
    slug: "vivere-con-impianto-cocleare-consigli",
    title: "Vivere con l'impianto cocleare: consigli pratici quotidiani",
    excerpt: "Dalla cura del processore all'uso in ambienti rumorosi: piccoli accorgimenti per la vita di tutti i giorni.",
    img: "/assets/paziente.jpg",
    date: "2026",
    tag: "Impianto Cocleare",
  },
  {
    slug: "manutenzione-impianto-cocleare-protesi",
    title: "Manutenzione di impianti e protesi: la guida essenziale",
    excerpt: "Pulizia, batterie, umidità e controlli periodici: come far durare a lungo i tuoi dispositivi uditivi.",
    img: "/assets/protesi.jpg",
    date: "2026",
    tag: "Manutenzione",
  },
  {
    slug: "ipoacusia-infantile-primi-segnali",
    title: "Ipoacusia infantile: riconoscere i primi segnali",
    excerpt: "I campanelli d'allarme nei bambini, l'importanza dello screening neonatale e cosa fare dopo la diagnosi.",
    img: "/assets/prove-udito.jpg",
    date: "2026",
    tag: "Ipoacusia",
  },
  {
    slug: "supporto-disabilita-uditiva-sicilia",
    title: "Come ottenere supporto per la disabilità uditiva in Sicilia",
    excerpt: "Una guida pratica ai primi passi: dalla diagnosi all'invalidità civile, fino al supporto delle associazioni.",
    img: "/assets/audioprotesista.jpg",
    date: "2026",
    tag: "Guida",
  },
  {
    slug: "diritti-persone-sorde-guida-pratica",
    title: "Diritti delle persone sorde: guida pratica 2026",
    excerpt: "Scuola, lavoro, sanità: quali sono i diritti riconosciuti e come farli valere nella vita di tutti i giorni.",
    img: "/assets/orecchio.jpg",
    date: "2026",
    tag: "Diritti",
  },
  {
    slug: "bonus-agevolazioni-2026-ipoacusia",
    title: "Bonus e agevolazioni 2026 per ipoacusia e sordità",
    excerpt: "Detrazioni, contributi per protesi e impianti, agevolazioni fiscali: cosa sapere per non perdere occasioni.",
    img: "/assets/cabina.jpg",
    date: "2026",
    tag: "Agevolazioni",
  },
];

export const CONTACT = {
  referente: "Luigi Casano",
  tel: "351 133 5477",
  email: "asi.sicilia.onlus@gmail.com",
  pec: "asi.sicilia.ets@pec.it",
  sede1: "Via Consolare Valeria, 1",
  sede2: "c/o Otorinolaringoiatria A.O.U. \u201cG. Martino\u201d",
  sede: "Via Consolare Valeria, 1 — c/o Otorinolaringoiatria A.O.U. \u201cG. Martino\u201d",
  citta: "98124 Messina (ME)",
  cf: "97122060839",
  iban: "IT13 L087 1383 9300 0000 0418 063",
  iban_plain: "IT13L0871383930000000418063",
  quota: "€10,00 / anno",
  rep: "Rep. n. 26948",
  runts: "Ente del Terzo Settore — RUNTS",
  fondata: "2016",
  areaRiservata: "https://gestionale.assofacile.it/login/calendario_free/index.php?idasso=asisiciliaonlus",
  candidatura: "https://gestionale.assofacile.it/login/calendario_free/iscriviti.php?idasso=asisiciliaonlus",
};
